<template>
    <div>
        <el-input
            ref="input"
            v-model="value"
            :placeholder="params.name"
            :disabled="disabled"
            @clear="clear"
            clearable
            @input="input">
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="show"
                :disabled="disabled"
            ></el-button>
        </el-input>
        <advance-dialog ref="advanceDialog" :maxSelect="maxSelect" :disableSearch="disableSearch" @confirm="detaliSearchSure" ></advance-dialog>
    </div>
</template>

<script>
import advanceDialog from '@/components/lots/otpAdvanceDialog';
export default {
    components: { advanceDialog },
    props: {
        params: Object,
        mValue: [String, Number],
        disabled: {
            type: Boolean,
            default: false
        },
        disableSearch: {
            type: Boolean,
            default: false
        },
        maxSelect: { // 最多可选数
            type: Number,
            default: 0
        },
        formData: {
            type: Object,
            default() {
                return {};
            }
        },
        cacheData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            value: ''
        };
    },
    created() {
        this.value = this.mValue;
    },
    watch: {
        mValue() {
            this.value = this.mValue;
        }
    },
    methods: {
        input() {
            const obj = {};
            this.params.cbParams.forEach(item => {
                var arr = item.split('#');
                obj[arr[arr.length - 1]] = '';
            });
            if (this.params.inputable) {
                obj[this.params.value] = this.value;
            } else {
                this.value = '';
            }
            this.$emit('getAdvanceValue', obj);
        },
        show() {
            const current = this.params;
            let advanceCascade = {};
            if (current.advanceCascade && Object.prototype.toString.call(current.advanceCascade) === '[object String]') {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.formData[sourceProp];
                });
            } else if (current.advanceCascade && Object.prototype.toString.call(current.advanceCascade) === '[object Object]') {
                advanceCascade = current.advanceCascade;
            }
            const { mode, advanceRequire } = current;
            if (advanceRequire && advanceRequire.length > 0) {
                let flag = true;
                advanceRequire.forEach(ad => {
                    if (!this.formData[ad.prop]) {
                        flag = false;
                        this.$message.warning(ad.message);
                    }
                });
                if (!flag) { return false; }
            }
            if (current.rule) {
                const { message, validate, async } = current.rule;
                // async区分走不走接口校验
                if (async && validate && typeof validate === 'function') {
                    const result = validate(this.formData);
                    if (result instanceof Promise) {
                        result.then(valid => {
                            if (!valid) {
                                this.$message.warning(message || '校验不通过，点击失效');
                                this.$refs.advanceDialog.show(false, current, advanceCascade, mode, this.cacheData);
                            } else {
                                this.$refs.advanceDialog.show(true, current, advanceCascade, mode, this.cacheData);
                            }
                        });
                    }
                    return false;
                }
                // 走接口校验则不走下面部分
                if (validate && typeof validate === 'function' && !validate()) {
                    this.$message.warning(message || '校验不通过，点击失效');
                    return false;
                }
            }
            this.$refs.advanceDialog.show(true, current, advanceCascade, mode, this.cacheData);
        },
        detaliSearchSure(data) {
            this.value = data[this.params.value];
            this.$emit('getAdvanceValue', data);
        },
        clear() {
            this.value = '';
            this.$emit('clear', '');
        }
    }
};
</script>

<style>
</style>
